import { ChatroomHeader } from './ChatroomHeader';
import RDSChatroom from './RDSChatroom';

export const Chatroom = ({ token, user, chatroomKey, orderKey }) => {
	const userName = user?.isAnonymous ? user?.userName?.replace(/^anon_/, '') : "USER";
	return (
		<div className="h-full flex-grow relative flex flex-col">
			<ChatroomHeader orderKey={orderKey} />
			<div className="h-full grid overflow-y-scroll">
				<RDSChatroom
					token={token}
					currentUserName={userName}
					canReview={true}
					chatroomKey={chatroomKey ?? ''}
					isCompact
					inGodMode={false}
					language="original"
				/>
			</div>
		</div>
	);
};
